export function scrollToElement(id: string, behavior?: ScrollBehavior): void {
  const el = document.getElementById(id);
  if (!el) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const resolvedBehavior = behavior ?? (prefersReducedMotion ? 'auto' : 'smooth');

  el.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : resolvedBehavior,
    block: 'start',
  });
}
